module.exports = __webpack_public_path__ + "assets/img/s3_chart-4.6238096b.png";